import { inlineRuns } from '@ads/shared';
import { createElement, Fragment, type ReactNode } from 'react';

/** Texto com **ênfase** → nós React, sem HTML cru. */
export function rich(text: string, strongClass?: string): ReactNode {
  return createElement(Fragment, null, ...inlineRuns(text).map((r, i) =>
    r.strong ? createElement('b', { key: i, className: strongClass, style: strongClass ? undefined : { fontWeight: 560 } }, r.text) : r.text));
}

const dtf = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
const dtfTime = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
export const dateLong = (iso: string) => dtf.format(new Date(iso)).replace(/\./g, '');
export const dateTime = (iso: string) => dtfTime.format(new Date(iso)).replace(/\./g, '');
export const dateBR = (iso: string) => (iso ? iso.split('-').reverse().join('/') : '—');
const money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
export const brl = (n: number | null) => (n == null ? '—' : money.format(n).replace(/ /g, ' '));
export const pct = (x: number) => Math.round(x * 100);
